import InfoBox from "./InfoBox";


export default function NotesBox(props) {

    const content = [];
    for (let noteId in props.notes) {
        const note = props.notes[noteId];
        if (note.deleted) continue;

        const cnt = {
            source: (note.is_public ? '[public note] User: ' : 'User: ') + note.user_id,
            comment: note.content,
            timestamp: [0, Date.now() + 10*365*24*3600*1000],
            noteObj: note
        }
        content.push(cnt);
    }

    if (content.length === 0) {
        return <></>
    }

    return (
        <InfoBox
            label='Notes'
            content={content}
            custom={true}
            onEdit={props.onEdit}
            onDelete={props.onDelete}
        />
    )
}
